import React from 'react'
import { AsyncSelect } from './AsyncSelect'
import { baseUrl } from 'utils/axios'
import { Option } from './Select'

export const DepartmentSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
  error,
  defaultSelectFirstOption = false,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
  error?: string
  defaultSelectFirstOption?: boolean
}) => {
  return (
    <AsyncSelect<{ id: number; name: string }>
      width={width}
      label={label}
      optionKey='departments'
      defaultSelectFirstOption={defaultSelectFirstOption}
      placeholder={placeholder || 'All Departments'}
      nullValue={placeholder ? undefined : { label: 'All Departments', value: null }}
      loadOptions={async (search) => {
        const data = await baseUrl.get('/departments', {
          params: {
            q: search,
          },
        })
        return data.data.data.map((item) => ({
          id: item.id,
          name: item.name,
        })) as { id: number; name: string }[]
      }}
      decoder={(item) => ({
        label: item.name,
        value: item.id,
      })}
      onChange={(value) => onChange(value)}
      value={value}
      error={error}
    />
  )
}
